import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo } from 'react';
import { styled } from 'styled-components';
import { baseHtmlBasedPreviewStyles } from '../html.config.js';
import { purifyHTMLPreview } from '../html.utils.js';
import truncate from '../../../node_modules/truncate-html/dist/truncate.es.js';

const HtmlDiv = styled.div.withConfig({
  displayName: "HTMLRender__HtmlDiv",
  componentId: "sc-385acaa1-0"
})([
  ``,
  ``
], baseHtmlBasedPreviewStyles);
const HTMLRender = /* @__PURE__ */ forwardRef(({ html, truncate: truncate$1, ...props }, ref) => {
  const content = useMemo(() => {
    const purifiedHTML = purifyHTMLPreview(html);
    return truncate$1 ? truncate(purifiedHTML, truncate$1)?.toString() ?? "" : purifiedHTML;
  }, [
    html,
    truncate$1
  ]);
  return /* @__PURE__ */ jsx(HtmlDiv, {
    ...props,
    ref,
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
});
HTMLRender.displayName = "HTMLRender";

export { HTMLRender };
//# sourceMappingURL=HTMLRender.js.map
